import styled from "styled-components";
import Theme from "../../../styles/Theme/Theme";


export const Text = styled.p`
   display: flex;
   margin: 0;
   font-family: ${Theme.typography.fontFamily};
   margin-right: ${props => (props.$marginRight ? Theme.spacing[props.$marginRight] : null)};
   margin-left: ${props => (props.$marginLeft ? Theme.spacing[props.$marginLeft] : null)};
   margin-bottom: ${props => (props.$marginBottom ? Theme.spacing[props.$marginBottom] : null)};
   margin-top: ${props => (props.$marginTop ? Theme.spacing[props.$marginTop] : null)};
   
   color: ${props => (props.$fontColor ? Theme.color[props.$fontColor] : null)};
   
   font-weight: ${props => (props.$weight ? Theme.typography.weight[props.$weight] : null)};
   
   font-size: ${props => (Theme.typography.fontSize[props.$fontSize + '_desktop'])};
   align-items: ${props => props.$alignItems ?? null};

   // @media ${Theme.devices.videowall} {
   //    font-size: ${props => (Theme.typography.fontSize[props.$fontSize + '_videowall'])}
   //    margin-right: ${props => (props.$marginRight ? Theme.spacing[props.$marginRight] : null)};
   //    margin-left: ${props => (props.$marginLeft ? Theme.spacing[props.$marginLeft] : null)};
   //    margin-bottom: ${props => (props.$marginBottom ? Theme.spacing[props.$marginBottom] : null)};
   //    margin-top: ${props => (props.$marginTop ? Theme.spacing[props.$marginTop] : null)};
   // }
`;